import {ready} from 'dauphine-js';
import './components/_navMain';
import './utils/_accordion.js';
import './components/_actusSlider';

ready(() => {

});
